'use strict';

function CompanyPublicationCompanyInvestigationService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/investigation', {}, {
    'update': {
      method: 'PUT'
    },
    'queryUsersInvestigation':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/users',
      method: 'GET',
      isArray: true
    },
    'addUsersInvestigation':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/users',
      method: 'POST'
    },
    'deleteUsersInvestigation':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/users/:invesUserId',
      method: 'DELETE'
    },
    'queryInvestigationInfors':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors',
      method: 'GET',
      isArray: true
    },
    'addInvestigationInfor':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors',
      method: 'POST'
    },
    'updateInvestigationInfor':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors/:investigationInforId',
      method: 'PUT'
    },
    'deleteInvestigationInfor':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors/:investigationInforId',
      method: 'DELETE'
    },
    'decisionPdf':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/decision-pdf',
      method: 'POST'
    },
    'decisionDonePdf':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/decision-done-pdf',
      method: 'POST'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationCompanyInvestigationService', ['$resource', 'config', CompanyPublicationCompanyInvestigationService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/investigation/CompanyPublicationCompanyInvestigationService.js
// module id = 401
// module chunks = 0